import { apiClient } from '@/shared/lib/axios';
import {
  SpecialCalculationCost,
  SpecialCalculationCostQuery,
} from '@/types/special-calculation-cost';

type ListResponse = {
  data: {
    data: SpecialCalculationCost[];
    meta: {
      total: number;
      per_page: number;
      current_page: number;
      last_page: number;
    };
    links: {
      prev: string | null;
      next: string | null;
    };
  };
};

export const getSpecialCalculationCosts = async (
  siteType: string,
  params?: SpecialCalculationCostQuery
): Promise<ListResponse> => {
  const response = await apiClient.get<ListResponse>(
    `/admin/${siteType}/special_calculation_costs`,
    { params }
  );
  return response.data;
};

export const getSpecialCalculationCost = async (
  siteType: string,
  id: number
): Promise<{ data: SpecialCalculationCost }> => {
  const response = await apiClient.get<{ data: SpecialCalculationCost }>(
    `/admin/${siteType}/special_calculation_costs/${id}`
  );
  return response.data;
};

export const downloadSpecialCalculationCostCsv = async (
  siteType: string,
  params: SpecialCalculationCostQuery | undefined = undefined
): Promise<void> => {
  const response = await apiClient.get(`/admin/${siteType}/special_calculation_costs/csv`, {
    params,
    responseType: 'blob',
  });

  const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `special_calculation_costs${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.csv`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
